import { m } from 'framer-motion';

const navItems = {
  '/': { name: 'Home' },
  '#about': { name: 'About' },
  '#experience': { name: 'Experience' },
  '#projects': { name: 'Projects' },
};

export function Nav({ isDark = true, children }) {
  return (
    <m.nav
      aria-label="Main navigation"
      className="flex items-center justify-between py-6"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* Nav is wayfinding data, not voice — mono, uppercase, wide-tracked */}
      <div className="flex items-center gap-5 sm:gap-7">
        {Object.entries(navItems).map(([path, { name }], index) => (
          <m.a
            key={path}
            href={path}
            className={`u-label hidden transition-colors duration-200 md:block ${
              isDark
                ? 'text-neutral-600 hover:text-neutral-200'
                : 'text-neutral-400 hover:text-neutral-900'
            }`}
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.1 + index * 0.05 }}
          >
            {name}
          </m.a>
        ))}
      </div>
      <div className="flex items-center gap-4">
        {children}
      </div>
    </m.nav>
  );
}
